import api from './api.config';

// Dashboard APIs
export const dashboardAPI = {
  getAdminDashboard: async () => {
    const response = await api.get('/dashboard/admin');
    return response.data;
  },
  
  getCadreDashboard: async () => {
    const response = await api.get('/dashboard/cadre');
    return response.data;
  },
  
  getCommunityDashboard: async () => {
    const response = await api.get('/dashboard/community');
    return response.data;
  },
  
  getClientDashboard: async () => {
    const response = await api.get('/dashboard/client');
    return response.data;
  },
  
  getPanelAdminDashboard: async (panelId) => {
    const endpoint = panelId 
      ? `/dashboard/panel-admin/${panelId}` 
      : '/dashboard/panel-admin';
    const response = await api.get(endpoint);
    return response.data;
  },
  
  getStats: async () => {
    const response = await api.get('/dashboard/stats');
    return response.data;
  },

  getDeadlines: async () => {
    const response = await api.get('/dashboard/deadlines');
    return response.data;
  },

  getActivity: async (limit = 20) => {
    const response = await api.get('/dashboard/activity', { params: { limit } });
    return response.data;
  }
};

export default dashboardAPI;
